"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ChatbotHeader = _interopRequireDefault(require("./Components/ChatbotHeader/ChatbotHeader"));

var _ChatbotMessenger = _interopRequireDefault(require("./Components/ChatbotMessenger/ChatbotMessenger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chatbot = function Chatbot(_ref) {
  var display = _ref.display,
      initials = _ref.initials,
      postMessage = _ref.postMessage,
      linkTyC = _ref.linkTyC;
  var chatLog = display.chatLog,
      displayMessage = display.displayMessage,
      clearChatLog = display.clearChatLog;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chatbotContainer shadow"
  }, /*#__PURE__*/_react.default.createElement(_ChatbotHeader.default, {
    clearChatLog: clearChatLog,
    isClearChatActive: chatLog.length > 0
  }), /*#__PURE__*/_react.default.createElement(_ChatbotMessenger.default, {
    chatLog: chatLog,
    displayMessage: displayMessage,
    initials: initials,
    postMessage: postMessage,
    linkTyC: linkTyC
  }));
};

var _default = Chatbot;
exports.default = _default;